export default "__VITE_ASSET__CpnfPh5H__"